import { IInboundEmailCommunication } from 'shared';

import { InboxTable } from '../common/InboxTable';

import { EmailInboxRow } from './EmailInboxRow';

interface EmailInboxTableProps {
  rows: IInboundEmailCommunication[];
  onRowClick: (email: IInboundEmailCommunication) => void;
}

export function EmailInboxTable({
  rows,
  onRowClick,
}: EmailInboxTableProps) {
  return (
    <InboxTable
      columns={ [
        { key: `received`, label: `Received` },
        { key: `contact`, label: `Contact` },
        { key: `from`, label: `From` },
        { key: `subject`, label: `Subject` },
        { key: `reply`, label: `Reply` },
      ] }
      emptyMessage={ `No inbound emails yet.` }
      hasRows={ rows.length > 0 }
    >
      { rows.map(email => (
        <EmailInboxRow
          key={ email.id }
          email={ email }
          onRowClick={ onRowClick }
        />
      )) }
    </InboxTable>
  );
}
